import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'react-bootstrap';
import './TaskSummary.css';
import Number from 'components/shared/text/Number';
import Date from 'components/shared/text/Date';
import ImageUpload from 'components/shared/image-upload/ImageUpload';
import TasksUtil from 'services/utils/tasks-util';
import Button from 'components/shared/button/Button';

class TaskSummary extends Component {
  static propTypes = {
    task: PropTypes.shape({
      id: PropTypes.number,
      description: PropTypes.string,
      dueDate: PropTypes.string,
      floor: PropTypes.string,
      images: PropTypes.arrayOf(
        PropTypes.shape({
          preview: PropTypes.string,
          url: PropTypes.string,
        })
      ),
      number: PropTypes.number,
      room: PropTypes.string,
      name: PropTypes.string,
      trade: PropTypes.string,
    }).isRequired,
    onTaskDelete: PropTypes.func,
    onTaskEdit: PropTypes.func,
  };

  render() {
    return (
      <div className="task-summary">
        <div className="item-title">{this.props.task.trade}</div>
        <div className="item-title">
          Task{' '}
          <span>
            #<Number value={this.props.task.number} format={'00'} />
          </span>
          <div className="edit-delete-buttons">
            <Button
              label="Edit"
              className="button-gray summary-edit-button"
              onClick={this.handleTaskEdit}
            />
            <Button
              label="Delete"
              className="button-gray summary-edit-button"
              onClick={this.handleTaskDelete}
            />
          </div>
        </div>

        <table>
          <colgroup>
            <col />
            <col />
          </colgroup>
          <tbody>
            <tr>
              <td>Completion Date</td>
              <td>
                <Date value={this.props.task.dueDate} format={'M/D/YYYY'} />
              </td>
            </tr>
            {!TasksUtil.validateTaskCompletionDate(this.props.task.dueDate) && (
              <tr>
                <td />
                <td>
                  <Alert bsStyle="warning" className="completion-date-warning">
                    Completion date is 5 days or less from request. Please
                    confirm completion date.
                  </Alert>
                </td>
              </tr>
            )}
            <tr>
              <td>Floor</td>
              <td>{this.props.task.floor}</td>
            </tr>
            <tr>
              <td>Room</td>
              <td>{this.props.task.room}</td>
            </tr>
            <tr>
              <td>Task Name</td>
              <td>{this.props.task.name}</td>
            </tr>
            <tr>
              <td>Description</td>
              <td>{this.props.task.description}</td>
            </tr>
          </tbody>
        </table>

        <div className="images-container">
          <ImageUpload
            images={this.props.task.images} //.map(image => { return { url: image.url, preview: image.preview }})}
            readOnly={true}
          />
        </div>
      </div>
    );
  }

  handleTaskEdit = () => {
    if (this.props.onTaskEdit !== undefined) {
      this.props.onTaskEdit(this.props.task.id);
    }
  };

  handleTaskDelete = () => {
    if (this.props.onTaskDelete !== undefined) {
      this.props.onTaskDelete(this.props.task.id, this.props.task.number);
    }
  };
}

export default TaskSummary;



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/creation/TaskSummary.js